/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, lazy, Suspense } from 'react';
import MetaTags from 'react-meta-tags';
import BlockContent from '../../components/BlockContent';
import BlockChart from '../../components/BlockChart';
import QuizWidget from '../../components/QuizWidget';
import ItemChart from '../../containers/ItemChart';
// import PlaylistContainer from '../../components/PlaylistContainer';
import {
  getPlaylistChart,
  getCurrentBanner,
  getLatestNews,
  getChartTracks,
  getNoveltyChart,
  getChartTimestamp,
  getPollData,
  getAllActiveQuizes
} from './requests';
import prependPlaylistLastSong from '../../helpers/prependPlaylistLastSong';
import { loadMediastataPollScript } from '../../helpers/mediastataPoll';
// import CarouselWidget from '../../components/CarouselWidget';
// import BannerWidget from '../../components/BannerWidget';
import './index.css';
import Chart from '../../containers/Chart';
import setLocalStorageForLikes from '../../helpers/setLocalStorageForLikes';
const CarouselWidget = lazy(() => import('../../components/CarouselWidget'));
const BannerWidget = lazy(() => import('../../components/BannerWidget'));
const PlaylistContainer = lazy(() => import('../../components/PlaylistContainer'));
import {useSelector} from 'react-redux';
import {MUSIC, PLAYLIST, NOVELTY, NOVELTY_ICON, PLAYLIST_ICON, MUSIC_ICON, QUIZ_ICON } from '../../constants/routes';

export default function Main() {
  const [playlistChartData, setPlaylistChartData] = useState({});
  const [noveltyChartData, setNoveltyChartData] = useState([]);
  const [bannerData, setBannerData] = useState(null);
  const [sliderNewsData, setSliderNewsData] = useState(null);
  const [chartData, setChartData] = useState([]);
  const [ratedTracks, setRatedTracks] = useState([]);
  const [likedTracks, setLikedTracks] = useState([]);
  const [poll, setPoll] = useState([]);
  const [quizes, setQuizes] = useState([])
  const {playlistLastSong} = useSelector((state) => state);

  const setLocalStorage = async () => {
    const response = await getChartTimestamp();
    const timestamp = response?.data?.timestamp;
    if (!timestamp) {
      return;
    }
    const [actualRatedTracks, actualLikedTracks] = setLocalStorageForLikes(timestamp);
    setRatedTracks([...actualRatedTracks]);
    setLikedTracks([...actualLikedTracks]);
  }

  async function processingRequest() {
    setChartData((await getChartTracks()).data);
    setPlaylistChartData((await getPlaylistChart()).data);
    setNoveltyChartData((await getNoveltyChart()).data);
    setBannerData((await getCurrentBanner()).data);
    setSliderNewsData((await getLatestNews()).data);
    setPoll((await getPollData()).data);
    setQuizes((await getAllActiveQuizes()).data);
    await setLocalStorage();
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    processingRequest(); 
  }, []);

  // const asyncGetPlaylistChartData = async () => {
  //   setPlaylistChartData((await getPlaylistChart()).data);
  // }

  // const changePlayList = (last, tracks) => {
    
  //   tracks.pop();
  //   tracks.unshift(last);
  //   console.log("tracks", tracks)
  //   return tracks;
  // }

    useEffect(() => {
      if (playlistLastSong.id && playlistChartData.id) {
        setPlaylistChartData(
          {
            ...playlistChartData,
            track_list: prependPlaylistLastSong(playlistChartData.track_list, playlistLastSong),
          }
        );
      }
  }, [playlistLastSong]);

  useEffect(() => {
    const src = typeof poll?.content === 'string' ? poll.content.trim() : '';
    if (!poll?.active || !src) {
      return undefined;
    }
    return loadMediastataPollScript(src);
  }, [poll]);

  return (
    <div className="page-main">
      <MetaTags>
        <title>Новое Радио</title>
        <meta name="description" content="Главная - Новое Радио" />
      </MetaTags>
      <BlockContent left>
        <div className="big-column__chart">
          <Suspense key="flyaway-chart" fallback={<p>Loading</p>}>
            <PlaylistContainer
              chartData={chartData}
              title={"Улетный чарт"}
              link={MUSIC}
              icon={MUSIC_ICON}
              countViewTracks={10}
              additionalClass = {"flyaway-chart"}
              children={chartData.track_list}
              type={"chart"}
              color={null}
              moreBtn={true}
            />
          </Suspense>
        </div>
        <div className="small-column__chart">
        {playlistChartData && (
          <Suspense key="playlist-chart" fallback={<p>Loading</p>}>
            <PlaylistContainer
                chartData={playlistChartData.track_list}
                title={playlistChartData.title}
                link={PLAYLIST}
                icon={PLAYLIST_ICON}
                countViewTracks={4}
                additionalClass = {"playlist"}
                children={playlistChartData.track_list}
                type={"playlistChart"}
                color={null}
              />
          </Suspense>
        )}
          {noveltyChartData && (
            <Suspense key="novelty-chart" fallback={<p>Loading</p>}>
              <PlaylistContainer
                  chartData={noveltyChartData}
                  title={"Новинки"}
                  link={NOVELTY}
                  icon={NOVELTY_ICON}
                  countViewTracks={4}
                  additionalClass = {"new_songs"}
                  children={noveltyChartData}
                  type={"noveltyChart"}
                  color="yellow"
                />
            </Suspense>
          )}
        </div>
      </BlockContent>

      {quizes.length > 0 && (
        <BlockContent>
          <div className="quiz-container">
            <div className="chart-info">
              <img src={QUIZ_ICON} className="chart-info__icon" alt="" />
              <span className="chart-info__title">Опрос</span>
            </div>
            {/* {console.log("quizes", quizes)} */}
            {quizes.map((quiz) => (
                <QuizWidget key={quiz.id ?? quiz.title} elem={quiz} />
            ))}
          </div>
        </BlockContent>
      )}
      
      <BlockContent className="footer-block">
        <div className="big-column">
          <div className="slider-padding">
          <Suspense fallback={<p>Loading</p>}>
            <CarouselWidget sliderTitle="Что нового" data={sliderNewsData}/>
          </Suspense>
          </div>
        </div>
        <div className="small-column">
          {bannerData && bannerData.map((elem, index) => (
          <Suspense key={elem.id ?? `banner-${index}`} fallback={<p>Loading</p>}>
            <BannerWidget img={elem.picture} redirect={elem.link}/>
          </Suspense>
          ))}
        </div>
      </BlockContent>
    </div>
  );
}
